export const enAdminFixes = {
	title: "Admin fixes",
	subtitle:
		"Run a data repair over one list. Every fix is queued rather than run in the request — a list can hold tens of thousands of leads — so the outcome appears in the table below once the worker finishes. Start with a dry run: it reports exactly what would change without writing anything.",
	company: "Company",
	list: "List",
	fix: "Fix",
	searchCompany: "Search companies…",
	searchList: "Search lists…",
	searchFix: "Search fixes…",
	loadingLists: "Loading lists…",
	chooseCompanyFirst: "Pick a company first",
	dryRun: "Dry run",
	dryRunHint: "Dry run — report what would change without writing anything",
	run: "Queue the run",
	queueing: "Queueing…",
	queued: "Queued. The table below updates when the worker picks it up.",
	notQueued: "Not queued.",
	status: {
		queued: "Queued",
		running: "Running",
		done: "Done",
		failed: "Failed",
	},
	runs: {
		instanceWide: "Whole instance",
		title: "Recent runs",
		empty: "Nothing has been run yet.",
		fix: "Fix",
		list: "List",
		status: "Status",
		outcome: "Outcome",
		started: "Started",
		company: "· company {{id}}",
		failed: "Failed",
		noReportYet: "—",
		summary:
			"{{changed}} lead(s) changed · {{titles}} title(s) classified · {{withoutSeniority}} without seniority",
	},
	instanceWide:
		"This fix runs across the whole instance, so it needs no company or list. It is not scoped to one tenant.",
	companyScoped: "This fix runs over one company's data and needs no list — pick the company only.",
};
